<template>

    <section>

        <!-- ここから -->
        <div class="axis_component md_common-bl _padding-add">
            <div class="inner">

                <!-- Genre -->
                <div class="row-item _genre">
                    <div class="title"><span>取り扱い商品のジャンル登録</span></div>
                    <div class="detail"><span>Apparel</span></div>
                </div>

                <!-- Category -->
                <div class="row-item _category">
                    <div class="title"><span>取り扱い商品のカテゴリ登録</span></div>
                    <div class="detail"><span>Tシャツ</span><span>アウター</span><span>パンツ</span></div>
                </div>

                <!-- Edit -->
                <div class="edit-item-wrap">
                    <div class="title">取り扱い商品種類と価値軸</div>

                    <!-- SelectItemWrap -->
                    <div class="select-item-wrap">

                        <!-- Item -->
                        <div class="select-row">
                            <div class="title"><span>Tシャツ</span></div>
                            <div class="item form_select">
                                <div class="input-row">
                                    <select name="" id="">
                                        <option value="">example1</option>
                                        <option value="">example2</option>
                                        <option value="">example3</option>
                                        <option value="">example4</option>
                                    </select>
                                </div>
                            </div>
                            <div class="detail"><span>Luxury</span></div>
                        </div>

                        <!-- Item -->
                        <div class="select-row">
                            <div class="title"><span>アウター</span></div>
                            <div class="item form_select">
                                <div class="input-row">
                                    <select name="" id="">
                                        <option value="">example1</option>
                                        <option value="">example2</option>
                                        <option value="">example3</option>
                                        <option value="">example4</option>
                                    </select>
                                </div>
                            </div>
                            <div class="detail"><span>Highclass</span></div>
                        </div>

                        <!-- Item -->
                        <div class="select-row">
                            <div class="title"><span>パンツ</span></div>
                            <div class="item form_select">
                                <div class="input-row">
                                    <select name="" id="">
                                        <option value="">example1</option>
                                        <option value="">example2</option>
                                        <option value="">example3</option>
                                        <option value="">example4</option>
                                    </select>
                                </div>
                            </div>
                            <div class="detail"><span>Highclass</span></div>
                        </div>

                    </div><!-- /SelectItemWrap -->

                    <div class="result-wrap">
                        <div class="box">
                            <p class="top">AUMAの中でこのブランドの価格軸は</p>
                            <p class="middle"><span>Highclass</span></p>
                            <p class="bottom">です。</p>
                        </div>
                    </div>

                </div><!-- /Edit -->

                <!-- BtnLinkWrap -->
                <div class="btn_link-wrap">

                    <button class="btn_link _cancel md_icon-text">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCancel /></div>承認しない</span>
                        </div>
                    </button>

                    <button class="btn_link md_icon-text _white">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>承認する</span>
                        </div>
                    </button>

                </div><!-- /.BtnLinkWrap -->

            </div>
        </div>
        <!-- ここまで -->

    </section>

</template>

<script>
    //Svg
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'

    export default {
        components: {
            //Svg
            SvgIconCancel,
            SvgIconCheck,
        },
    }
</script>
